import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PermissionGroup } from './permission-group.model';
import * as PermissionGroupActions from './permission-group.actions';

export const permissionGroupsFeatureKey = 'permissionGroups';

export interface State extends EntityState<PermissionGroup> {
  // additional entities state properties
}

export const adapter: EntityAdapter<PermissionGroup> = createEntityAdapter<PermissionGroup>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(PermissionGroupActions.addPermissionGroup,
    (state, action) => adapter.addOne(action.permissionGroup, state)
  ),
  on(PermissionGroupActions.upsertPermissionGroup,
    (state, action) => adapter.upsertOne(action.permissionGroup, state)
  ),
  on(PermissionGroupActions.addPermissionGroups,
    (state, action) => adapter.addMany(action.permissionGroups, state)
  ),
  on(PermissionGroupActions.upsertPermissionGroups,
    (state, action) => adapter.upsertMany(action.permissionGroups, state)
  ),
  on(PermissionGroupActions.updatePermissionGroup,
    (state, action) => adapter.updateOne(action.permissionGroup, state)
  ),
  on(PermissionGroupActions.updatePermissionGroups,
    (state, action) => adapter.updateMany(action.permissionGroups, state)
  ),
  on(PermissionGroupActions.deletePermissionGroup,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(PermissionGroupActions.deletePermissionGroups,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(PermissionGroupActions.loadPermissionGroups,
    (state, action) => adapter.setAll(action.permissionGroups, state)
  ),
  on(PermissionGroupActions.clearPermissionGroups,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
